export const WorkerErrorCode = {
  EMPTY_WORKSPACE_NEEDED: 'EMPTY_WORKSPACE_NEEDED',
  EMPTY_WORKSPACE: 'EMPTY_WORKSPACE',
};
